<template>
  <a-drawer
    :destroy-on-close="true"
    :title="isUpdate ? '办公设备编辑' : '办公设备创建'"
    :visible="visible"
    :width="800"
    @close="closeDrawer"
  >
    <a-form-model
      ref="form"
      :label-col="{
        span: 4,
        style: {
          textAlign: 'left'
        }
      }"
      :model="form"
      :rules="rules"
      :wrapper-col="{
        span: 20
      }"
    >
      <a-form-model-item label="名称" prop="name">
        <a-input v-model="form.name" :max-length="128"></a-input>
      </a-form-model-item>
      <a-form-model-item prop="groups">
        <question-icon
          slot="label"
          title="所属群组"
          description="用于分组查询"
        ></question-icon>
        <group-select v-model="form.groups" source-type="office_equipment"></group-select>
      </a-form-model-item>
      <a-form-model-item label="厂商" prop="vendor">
        <a-input v-model="form.vendor" :max-length="128"></a-input>
      </a-form-model-item>
      <a-form-model-item label="型号" prop="model">
        <a-input v-model="form.model" :max-length="128"></a-input>
      </a-form-model-item>
      <a-form-model-item label="CPU" prop="cpu">
        <a-input v-model="form.cpu" :max-length="128"></a-input>
      </a-form-model-item>
      <a-form-model-item label="内存" prop="memory">
        <a-input v-model="form.memory" :max-length="128"></a-input>
      </a-form-model-item>
      <a-form-model-item label="存储" prop="disk">
        <a-input v-model="form.disk" :max-length="128"></a-input>
      </a-form-model-item>
      <a-form-model-item label="操作系统类型" prop="osType">
        <a-input v-model="form.osType" :max-length="128"></a-input>
      </a-form-model-item>
      <a-form-model-item label="操作系统名称" prop="osName">
        <a-input v-model="form.osName" :max-length="128"></a-input>
      </a-form-model-item>
      <a-form-model-item label="位置" prop="location">
        <a-input v-model="form.location" :max-length="128"></a-input>
      </a-form-model-item>
      <a-form-model-item label="资产编号" prop="sn">
        <a-input v-model="form.sn" :max-length="128"></a-input>
      </a-form-model-item>
      <a-form-model-item label="IP 地址" prop="ipAddress">
        <a-input v-model="form.ipAddress" :max-length="128"></a-input>
      </a-form-model-item>
      <a-form-model-item label="申请时间" prop="appliedAt">
        <a-date-picker
          v-model="form.appliedAt"
          format="YYYY-MM-DD HH:mm"
          placeholder="请选择申请时间"
          :show-time="{
            format: 'HH:mm'
          }"
          style="width: 100%"
        ></a-date-picker>
      </a-form-model-item>
      <a-form-model-item label="申请人" prop="applicant">
        <a-input v-model="form.applicant" :max-length="128"></a-input>
      </a-form-model-item>
      <a-form-model-item label="处室" prop="office">
        <a-input v-model="form.office" :max-length="128"></a-input>
      </a-form-model-item>
      <a-form-model-item label="用途" prop="usage">
        <a-input v-model="form.usage" :max-length="128"></a-input>
      </a-form-model-item>
      <a-form-model-item label="所属业务" prop="service">
        <a-input v-model="form.service" :max-length="128"></a-input>
      </a-form-model-item>
      <a-form-model-item
        :wrapper-col="{ span: 20, offset: 4 }"
        style="margin-bottom: 0"
      >
        <a-space size="middle">
          <a-button :loading="loading" type="primary" @click="ok">
            确定
          </a-button>
          <a-button @click="closeDrawer">取消</a-button>
        </a-space>
      </a-form-model-item>
    </a-form-model>
  </a-drawer>
</template>

<script>
import moment from 'moment'
import {
  createOfficeEquipment,
  getOfficeEquipment,
  updateOfficeEquipment
} from '@/api/office-equipment'
import QuestionIcon from '@/components/icon/QuestionIcon'
import GroupSelect from '@/components/select/GroupSelect.vue'

export default {
  name: 'InputDrawer',
  components: {
    GroupSelect,
    QuestionIcon
  },
  data () {
    return {
      visible: false,
      isUpdate: false,
      form: {
        id: '',
        name: '',
        groups: undefined,
        vendor: '',
        model: '',
        cpu: '',
        memory: '',
        disk: '',
        osType: '',
        osName: '',
        location: '',
        sn: '',
        ipAddress: '',
        appliedAt: undefined,
        applicant: '',
        office: '',
        usage: '',
        service: ''
      },
      rules: {
        name: [
          {
            message: '请输入名称',
            required: true,
            trigger: 'blur'
          }
        ],
        groups: [
          {
            message: '请选择所属群组',
            required: true,
            trigger: 'select'
          }
        ]
      },
      loading: false
    }
  },
  methods: {
    show (id) {
      if (id) {
        this.isUpdate = true
        getOfficeEquipment(id)
          .then(res => {
            const data = res.data
            this.form = {
              id: data.id,
              name: data.name,
              groups: data.groups,
              vendor: data.vendor,
              model: data.model,
              cpu: data.cpu,
              memory: data.memory,
              disk: data.disk,
              osType: data.os_type,
              osName: data.os_name,
              location: data.location,
              sn: data.sn,
              ipAddress: data.ip_address,
              appliedAt: data.applied_at ? moment(data.applied_at, 'YYYY-MM-DD HH:mm') : undefined,
              applicant: data.applicant,
              office: data.office,
              usage: data.usage,
              service: data.service
            }
          })
          .finally(() => {
            this.visible = true
          })
      } else {
        this.isUpdate = false
        this.visible = true
      }
    },
    closeDrawer () {
      this.form = {
        id: '',
        name: '',
        groups: undefined,
        vendor: '',
        model: '',
        cpu: '',
        memory: '',
        disk: '',
        osType: '',
        osName: '',
        location: '',
        sn: '',
        ipAddress: '',
        appliedAt: undefined,
        applicant: '',
        office: '',
        usage: '',
        service: ''
      }
      this.$refs.form.resetFields()
      this.visible = false
    },
    ok () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.loading = true
          const params = {
            name: this.form.name,
            vendor: this.form.vendor,
            model: this.form.model,
            cpu: this.form.cpu,
            memory: this.form.memory,
            disk: this.form.disk,
            os_type: this.form.osType,
            os_name: this.form.osName,
            location: this.form.location,
            applicant: this.form.applicant,
            office: this.form.office,
            usage: this.form.usage,
            service: this.form.service
          }
          if (this.form.groups) {
            params.group_ids = this.form.groups.map(group => group.id)
          }
          if (this.form.appliedAt) params.applied_at = this.form.appliedAt.format('YYYY-MM-DD HH:mm')
          if (this.form.sn) params.sn = this.form.sn
          if (this.form.ipAddress) params.ip_address = this.form.ipAddress
          if (this.isUpdate) {
            updateOfficeEquipment(this.form.id, params)
              .then(res => {
                this.$message.success(res.message)
                this.$emit('ok')
                this.closeDrawer()
              })
              .finally(() => {
                this.loading = false
              })
          } else {
            createOfficeEquipment(params)
              .then(res => {
                this.$message.success(res.message)
                this.$emit('ok')
                this.closeDrawer()
              })
              .finally(() => {
                this.loading = false
              })
          }
        }
      })
    }
  }
}
</script>
